import { Pickem } from "model/Pickem/Pickem";
import { RankemDetails } from "model/PickemDetails/Rankem/Details";
import { selectTournamentSegment } from "selectors/Tournament";
import { ErrorText } from "styles/text";
import { LeaderboardPart } from "model/Leaderboard/User/SegmentLeaderboardUser";
import { PickemUserRankemBracketPicks } from "./PickemUserRankemBracketPicks";
import { BracketPicksContainer, RankemDriverPicksContainer } from "./styles";
import { selectPickemMatchIdsFromSegment } from "selectors/PickemDetails";
import { PickemUserRankemMatch } from "./PickemUserRankemMatch";
import { PickemUserDriverPick } from "../Matchem/PickemUserDriverPick";
import { useAppSelector } from "app/hooks";
import { PickemUserRankemSwissPicks } from "./PickemUserRankemSwissPicks";

interface Props {
  pickem: Pickem;
  rankemDetails: RankemDetails;
  leaderboardPart: LeaderboardPart | undefined;
}

export const PickemUserRankemPicks = ({
  pickem,
  rankemDetails,
  leaderboardPart,
}: Props) => {
  const tournamentSegment = useAppSelector((state) =>
    selectTournamentSegment(
      state,
      rankemDetails.tournamentId,
      rankemDetails.segmentId
    )
  );

  const matchIds = useAppSelector((state) =>
    !!tournamentSegment
      ? selectPickemMatchIdsFromSegment(state, tournamentSegment, rankemDetails)
      : []
  );

  const driverIds = pickem?.driverPicks ?? [];

  if (!tournamentSegment) {
    return <ErrorText>Unable to find tournament segment</ErrorText>;
  }

  if (tournamentSegment.type === "Bracket") {
    return (
      <>
        {tournamentSegment.groups.map((b) => (
          <BracketPicksContainer key={b.name}>
            <PickemUserRankemBracketPicks
              rankemDetails={rankemDetails}
              picks={pickem.picks}
              bracket={b}
              leaderboardPart={leaderboardPart}
              columns={rankemDetails.pointsRules.columns}
            />
          </BracketPicksContainer>
        ))}
      </>
    );
  }

  if (tournamentSegment.type === "Swiss") {
    return (
      <>
        {tournamentSegment.groups.map((s) => (
          <BracketPicksContainer key={s.name}>
            <PickemUserRankemSwissPicks
              rankemDetails={rankemDetails}
              picks={pickem.picks}
              swiss={s}
              leaderboardPart={leaderboardPart}
              columns={rankemDetails.pointsRules.columns}
            />
          </BracketPicksContainer>
        ))}
      </>
    );
  }

  return (
    <>
      {matchIds.map((matchId) => (
        <PickemUserRankemMatch
          key={matchId}
          picks={pickem.picks}
          leaderboardPart={leaderboardPart}
          columns={rankemDetails.pointsRules.columns}
          matchId={matchId}
          tournamentId={rankemDetails.tournamentId}
        />
      ))}
      {driverIds.length > 0 && (
        <RankemDriverPicksContainer>
          {driverIds.map((driverId) => {
            return (
              <PickemUserDriverPick
                key={driverId}
                driverId={driverId}
                driverPoints={
                  !!leaderboardPart?.driverPoints
                    ? leaderboardPart.driverPoints[driverId]
                    : undefined
                }
                tournamentId={rankemDetails.tournamentId}
              />
            );
          })}
        </RankemDriverPicksContainer>
      )}
    </>
  );
};
